// extracted by mini-css-extract-plugin
module.exports = {"table":"MachinesModal_table__111dL"};